import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  unselected: {
    position: 'relative',
    margin: '1rem 1.5rem',
    borderRadius: '5px',
    backgroundColor: theme.palette.common.white,
  },
  selected: {
    position: 'relative',
    margin: '1rem 1.5rem',
    borderRadius: '5px',
    backgroundColor: theme.palette.grey['200'],
  },
  option: {
    cursor: 'pointer',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    height: '8rem',
    width: '12rem',
    borderRadius: '5px',
    border: `1px solid ${theme.palette.primary.main}`,
    padding: '1rem',
    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.common.highlightBlue,
      boxShadow: `0px 0px 5px 0px ${theme.palette.primary.main}`,
    },
  },
  text: {
    width: '100%',
    textAlign: 'center',
    fontWeight: 500,
    clear: 'both',
    left: '-5px',
    position: 'relative',
  },
  icon: {
    position: 'absolute',
    top: 5,
    left: 5,
    fontSize: '2.5rem',
    color: theme.palette.common.tealish,
  },
}));

const MultipleChoiceOptions = ({item, options, handleAnswer, selectedValue=''}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {options.map(opt => (
        <div
          key={opt.id}
          className={selectedValue === opt.label ? classes.selected : classes.unselected}
        >
          <div
            className={classes.option}
            onClick={()=>handleAnswer(item, opt.label)}
          >
            {selectedValue === opt.label ? (<CheckCircleOutlineIcon className={classes.icon}/>) : null}
            <Typography
              variant="h3"
              className={classes.text}
            >
              {opt.label}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  );
};

MultipleChoiceOptions.propTypes = {
  item: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  handleAnswer: PropTypes.func.isRequired,
  selectedValue: PropTypes.string,
};

export default MultipleChoiceOptions;
